/**
 * Modo de desenvolvimento dos plugins web (docs/spec/web-plugins.md, "Modo de desenvolvimento"):
 * uma ficha ou tabela de um plugin instalado passa a vir de um endereço do computador de quem
 * programa (`http://localhost:5173/ficha.html`). Vale só neste navegador; os outros na mesa
 * continuam com a versão instalada.
 */
import { create } from 'zustand';

const KEY = 'rpgdesk.webdev';
type DevMap = Record<string, string>;

function load(): DevMap {
  try {
    const raw = window.localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as DevMap) : {};
  } catch {
    return {};
  }
}

const keyOf = (moduleId: string, type: string) => `${moduleId}|${type}`;

export const useDevUrls = create<{ urls: DevMap; set: (moduleId: string, type: string, url: string | null) => void }>()((set) => ({
  urls: load(),
  set: (moduleId, type, url) =>
    set((state) => {
      const urls = { ...state.urls };
      if (url) urls[keyOf(moduleId, type)] = url;
      else delete urls[keyOf(moduleId, type)];
      try {
        window.localStorage.setItem(KEY, JSON.stringify(urls));
      } catch {
        // sem armazenamento: vale até recarregar
      }
      return { urls };
    }),
}));

export const devUrlOf = (urls: DevMap, moduleId: string, type: string | null): string | null => (type ? (urls[keyOf(moduleId, type)] ?? null) : null);

/** Endereço aceito no modo de desenvolvimento: http(s) completo. O problema vem na língua pedida. */
export function devUrlProblem(url: string, lang: 'pt' | 'en' = 'pt'): string | null {
  try {
    const u = new URL(url);
    if (u.protocol === 'http:' || u.protocol === 'https:') return null;
    return lang === 'en' ? 'use an http:// or https:// address' : 'use um endereço http:// ou https://';
  } catch {
    return lang === 'en' ? 'it is not a valid address' : 'não é um endereço válido';
  }
}
